import {
  useDataSubmit,
  useDataValue,
  useDataChange,
  useDataFormat,
} from 'Simple/Data.js'

export function useOnClick(props) {
  let global = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
  })
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'global',
  })
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'global',
  })
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'patient',
    path: '_id',
  })
  let treatment_id = useDataValue({
    viewPath: props.viewPath,
    context: 'appointments',
    path: 'tx_uuid',
  })
  let tx_location = useDataFormat({
    viewPath: props.viewPath,
    context: 'treatment_plans',
    format: value => value.find(v => v._id === treatment_id)?.organization,
  })

  return async function onClick() {
    let sync = {
      patient_id,
      treatment_id,
      is_patient_overlay_call: true,
      location: tx_location,
    }

    if (global.tab_id !== 'Calendar') {
      await submit({
        type: global.tabs.includes('Calendar') ? 'tabs/select' : 'tabs/add',
        tab: {
          id: 'Calendar',
          name: 'Calendar',
          type: 'Calendar',
          viewPath: '/App/Account/Content/Calendar',
          sync,
        },
      })
    } else {
      change(next => {
        next.tabs = next.tabs.map(tab =>
          tab.id === 'Calendar'
            ? {
                ...tab,
                sync,
              }
            : tab
        )
      })
    }
  }
}
